<template>
  <div style="padding:25px;padding-top:45px;padding-bottom:45px;color:#7a7157;margin:0 35px">
    <div style="font-size:30px;text-align:center;font-weight:500;margin-bottom:20px">{{ titleText }}</div>
    <table border="0" cellspacing="0" cellpadding="0" 
      style="margin-left:auto;margin-right:auto;font-size:19px;line-height:33px; width:77%;">
      <tr valign="top">
        <td>
          <brown-link v-for="item in galleriesLeft" :key="item.gallery_id" :href="item.url + cclink" :name="item.name" />
        </td>
        <td style="width:12px"> &nbsp; </td>
        <td>
          <brown-link v-for="item in galleriesRight" :key="item.gallery_id" :href="item.url + cclink" :name="item.name" />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import BrownLink from './BrownLink.vue'

let stg = {
  galleries: ['/styles/3d-sl-cgi-rendering', '/styles/animals','/styles/architecture','/styles/beauty','/styles/black-and-white',
    '/styles/cartoon-and-humour','/styles/character-design', '/styles/children','/styles/collage-and-montage', '/styles/comic',
    '/styles/fantasy','/styles/fashion','/styles/food-and-drink','/styles/graphic','/styles/lettering','/styles/lifestyle',
    '/styles/line','/styles/nature','/styles/people', '/styles/portraits','/styles/vector', '/styles/watercolour']
} 

export default {
  props: {
    cclink: String,
    animation: Boolean,
    kidsbooks: Boolean
  },
  components: {
    BrownLink
  },
  data () {
    return {
      galleriesLeft: [],
      galleriesRight: [],
      titleText: 'Browse Illustrators by Style'
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    async loadData () {
      let ret = await this.$apix.get('collections/kb-galleries/UK')
      let gals = [];
      if(this.kidsbooks) {
        gals = ret.data.filter(el => (el.category.startsWith('kidsbooks')))
        this.titleText = 'Browse Illustrators by Style'
      }
      else if(this.animation) {
        gals = ret.data.filter(el => (el.animation))
        this.titleText = 'Browse Animators by Style'
      }
      else {
        gals = ret.data.filter(el => (!el.animation))
        gals = gals.filter(el => stg.galleries.includes(el.url))
        this.titleText = 'Browse Illustrators by Style'
      }
      gals = gals.sort((el, el2) => { return el.name.localeCompare(el2.name) })
      let mbr = Math.ceil(gals.length / 2)
      this.galleriesLeft = gals.slice(0, mbr)
      this.galleriesRight = gals.slice(mbr)
    }
  }
}
</script>

<style>

</style>